/* eslint no-console:0 */
import type { QueryClient } from '@tanstack/react-query';

import { projectKeys } from '@/enteties/project/api/projects.query-key';
import type { Projects } from '@/enteties/project/modal';

export function updateArrayItem<T>(
  setQueryData: (updater: (oldData: T[]) => T[]) => void,
  matchFn: (item: T) => boolean,
  propsToUpdate: Partial<T>
) {
  setQueryData((oldData) => {
    if (!oldData) {
      console.warn(`No existing data found.`);
      return oldData;
    }

    return oldData.map((item: T) =>
      matchFn(item) ? { ...item, ...propsToUpdate } : item
    );
  });
}

export function createSetQueryData<T extends any[]>(
  queryClient: QueryClient,
  queryKey: (string | number)[]
) {
  return (updater: (oldData: T) => T) => {
    queryClient.setQueryData<T>(queryKey, (oldData) => {
      if (!oldData) {
        console.warn(`No existing data found for key: ${queryKey}`);
        return oldData;
      }

      return updater(oldData);
    });
  };
}

export function createSetQueryDataWithPathname<T, K extends keyof T>(
  queryClient: QueryClient,
  queryKey: (string | number)[],
  pathToArray: K
) {
  return (updater: (oldArray: T[K] & any[]) => T[K]) => {
    queryClient.setQueryData<T>(queryKey, (oldData) => {
      if (!oldData) {
        console.warn(`No existing data found for key: ${queryKey}`);
        return oldData;
      }

      return {
        ...oldData,
        [pathToArray]: updater(oldData[pathToArray] as T[K] & any[]),
      };
    });
  };
}

export function getProjectsSetterQueryData(queryClient: QueryClient) {
  return createSetQueryDataWithPathname<Projects, 'services'>(
    queryClient,
    projectKeys.allProjects,
    'services'
  );
}
